function InventoryDashboard() {
  return (
    <>
      <div className="card p-5 font-bold"> Inventory Dashboard </div>
    </>
  );
}

export default InventoryDashboard;
